import * as React from 'react';

import * as styles from './AuthenticationModal.css';

interface IAuthenticationModalProps {
  children: React.ReactNode;
}

export const AuthenticationModal: React.FC<IAuthenticationModalProps> = ({ children }) => {
  return (
    <div className={styles['container']} data-mark="Authentication">
      {children}
    </div>
  );
};
